import { createSlice } from '@reduxjs/toolkit';
import {
  startOfDay,
  endOfDay
} from "date-fns";


// vitals - day

const today = new Date();
const startDate = startOfDay(today);

const endDate = endOfDay(today);

// questionnaire - week
let qStartDate = new Date();
qStartDate.setDate(today.getDate() - 7);

const initialState = {
  searchText: '',
  dateOrder: 'descending',
  timePeriod: 'Day',
  noteType: '',
  program: '',
  questionnaireFilter: 'timeline',
  startDate: startDate.toISOString(),
  endDate: endDate.toISOString(),
  questionnaireStartDate: startOfDay(qStartDate).toISOString(),
  questionnaireEndDate: endDate.toISOString(),
  questionnaireTimePeriod: 'Week',
  chartOptions: [
    { label: 'Oxygen Saturation', value: 'oxygenSaturation', showing: false },
    { label: 'ECG', value: 'ECG', showing: false },
    { label: 'HRV', value: 'ECGHRV', showing: false },
    { label: 'Blood Pressure', value: 'bloodPressure', showing: false },
    { label: 'Temperature', value: 'temperature', showing: false },
    { label: 'Respiratory Rate', value: 'respiratoryRate', showing: false },
    { label: 'Weight', value: 'weight', showing: false },
    { label: 'Auscultation', value: 'AUSC', showing: false },
    { label: 'Steps', value: 'steps', showing: false },
    { label: 'Glucose Level', value: 'glucoseLevel', showing: false }
  ],
  vitalsExpanded: false,
  selectedCharts: [], // We'll initialize this in the reducer,
  reportType: [], 
  selectedReportTypes: [],
  averageGrouped: false,
  readingInterval: 'Day',
  selectedScrollChart: ''
};

const patientDetailFilterSlice = createSlice({
  name: 'patientDetailFilter',
  initialState,
  reducers: {
    resetFilterState: (state) => {
      Object.assign(state, initialState);
    },
    setFilterItem: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
    },

    toggleVitalsExpanded(state) {
      state.vitalsExpanded = !state.vitalsExpanded;
    },
    toggleShowingTrue(state, action) {
      const value = action.payload;
      const isItemAlreadySelected = state.selectedCharts.some(item => item === value);
      if (!isItemAlreadySelected) {
        state.selectedCharts = [...state.selectedCharts, value]
      }
      state.chartOptions = state.chartOptions.map(option => {
          if (option.value === value) {
              return { ...option, showing: true };
          }
          return option;
      });
    },
    setSelectedCharts(state, action) {
      state.selectedCharts = action.payload;
    },
    setSelectedReportTypes: (state, action) => {
      state.selectedReportTypes = action.payload;
    },
    setReportTypes: (state, action) => {
      state.reportType = action.payload;
    },
    setAverageGrouped: (state, action) => {
      state.averageGrouped = action.payload;
    }
  },
});

export const {
  resetFilterState,
  setFilterItem,
  toggleVitalsExpanded,
  setSelectedCharts,
  toggleShowingTrue,
  setSelectedReportTypes,
  setReportTypes,
  setAverageGrouped
} = patientDetailFilterSlice.actions;

export default patientDetailFilterSlice.reducer;
